import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import deepmerge from 'deepmerge';
import { resolvePageMetadataImage } from '../components/PageMetadataImage';
import { useSiteMetadataContext } from '../contexts/site-metadata';
import { useAppSelector, withRedux } from '../redux';
import { getSchemaOrg } from './get-schema-org';
export const Head = withRedux(props => {
    const siteMetadata = useSiteMetadataContext();
    const dynamicJaenPageMetadata = useAppSelector(state => state.page.pages.nodes[props.pageContext.jaenPageId]?.jaenPageMetadata);
    const defaultTitle = props.location.pathname;
    const jaenPageMetadata = deepmerge(props.data.jaenPage?.jaenPageMetadata || {}, dynamicJaenPageMetadata || {});
    const metadataTitle = typeof jaenPageMetadata?.title === 'string'
        ? jaenPageMetadata.title
        : undefined;
    const configLabel = typeof props.pageContext.pageConfig?.label === 'string'
        ? props.pageContext.pageConfig.label
        : undefined;
    const title = metadataTitle || configLabel || siteMetadata?.title || defaultTitle;
    const description = jaenPageMetadata?.description || siteMetadata?.description;
    const normalizedSiteUrl = siteMetadata?.siteUrl?.replace(/\/+$/, '');
    const canonicalUrl = normalizedSiteUrl
        ? new URL(props.location.pathname || '/', `${normalizedSiteUrl}/`).toString()
        : undefined;
    const siteUrl = normalizedSiteUrl || '/';
    const url = canonicalUrl || props.location.pathname;
    const resolvedImage = resolvePageMetadataImage(jaenPageMetadata);
    const resolvedImageUrl = resolvedImage?.src && normalizedSiteUrl
        ? new URL(resolvedImage.src, `${normalizedSiteUrl}/`).toString()
        : resolvedImage?.src;
    const image = jaenPageMetadata?.image || resolvedImageUrl || siteMetadata?.image;
    const isBlogPost = !!jaenPageMetadata?.blogPost?.date || false;
    const datePublished = (isBlogPost && jaenPageMetadata?.blogPost?.date) || false;
    const fbAppID = siteMetadata?.social?.fbAppID;
    const twitter = siteMetadata?.social?.twitter;
    const schemaOrgJSON = getSchemaOrg({
        author: siteMetadata?.author,
        datePublished,
        defaultTitle,
        description,
        image,
        isBlogPost,
        organization: siteMetadata?.organization,
        title,
        siteUrl,
        url
    });
    return (_jsxs(_Fragment, { children: [_jsx("title", { id: "title", children: title }), _jsx("meta", { id: "meta-description", name: "description", content: description }), _jsx("meta", { id: "meta-image", name: "image", content: image }), canonicalUrl ? (_jsx("link", { id: "canonical-link", rel: "canonical", href: canonicalUrl })) : null, _jsx("meta", { id: "og-url", property: "og:url", content: url }), isBlogPost ? (_jsx("meta", { id: "og-type", property: "og:type", content: "article" })) : null, _jsx("meta", { id: "og-title", property: "og:title", content: title }), _jsx("meta", { id: "og-description", property: "og:description", content: description }), _jsx("meta", { id: "og-image", property: "og:image", content: image }), _jsx("meta", { id: "fb-app-id", property: "fb:app_id", content: fbAppID }), _jsx("meta", { id: "twitter-card", name: "twitter:card", content: "summary_large_image" }), _jsx("meta", { id: "twitter-creator", name: "twitter:creator", content: twitter }), _jsx("meta", { id: "twitter-title", name: "twitter:title", content: title }), _jsx("meta", { id: "twitter-description", name: "twitter:description", content: description }), _jsx("meta", { id: "twitter-image", name: "twitter:image", content: image }), _jsx("script", { id: "schema-org", type: "application/ld+json", children: JSON.stringify(schemaOrgJSON) }), props.children] }));
});
